<template>
  <HiDialog
    v-model="isOpen"
    width="35vw"
    :title="title"
    @submit="save"
    submitTxt="Save"
    :submitDisabled="saving"
  >
    <!--    <HiTextArea class="comment-input pa-2" ref="textarea"></HiTextArea>-->
    <div class="editor">
      <editor-floating-menu
        :editor="editor"
        v-slot="{ commands, isActive, menu }"
      >
        <div
          class="editor__floating-menu"
          :class="{ 'is-active': menu.isActive }"
          :style="`top: ${menu.top}px`"
        >
          <v-icon
            small
            class="menubar__button"
            :class="{ 'is-active': isActive.heading({ level: 3 }) }"
            @click="commands.heading({ level: 3 })"
            >mdi-format-header-1</v-icon
          >

          <v-icon
            small
            class="menubar__button"
            :class="{ 'is-active': isActive.bullet_list() }"
            @click="commands.bullet_list"
            >mdi-format-list-bulleted</v-icon
          >

          <v-icon
            small
            class="menubar__button"
            :class="{ 'is-active': isActive.ordered_list() }"
            @click="commands.ordered_list"
            >mdi-format-list-numbered</v-icon
          >
        </div>
      </editor-floating-menu>
      <editor-menu-bubble
        :editor="editor"
        :keep-in-bounds="keepInBounds"
        v-slot="{ commands, isActive, menu }"
      >
        <div
          class="menububble"
          :class="{ 'is-active': menu.isActive }"
          :style="`left: ${menu.left}px; bottom: ${menu.bottom}px;`"
        >
          <v-icon
            small
            class="menububble__button"
            :class="{ 'is-active': isActive.bold() }"
            @click="commands.bold"
            >mdi-format-bold</v-icon
          >

          <v-icon
            small
            class="menububble__button"
            :class="{ 'is-active': isActive.italic() }"
            @click="commands.italic"
            >mdi-format-italic</v-icon
          >
          <v-icon
            small
            class="menububble__button"
            :class="{ 'is-active': isActive.underline() }"
            @click="commands.underline"
            >mdi-format-underline</v-icon
          >
          <v-icon
            small
            class="menububble__button"
            :class="{ 'is-active': isActive.heading({ level: 3 }) }"
            @click="commands.heading({ level: 3 })"
            >mdi-format-header-1</v-icon
          >
        </div>
      </editor-menu-bubble>

      <editor-content class="editor__content" :editor="editor" ref="content" />
    </div>
    <div class="error-block" v-if="errorMsg">{{ errorMsg }}</div>
  </HiDialog>
</template>

<script>
import HiDialog from "@/components/HiDialog";
// import HiTextArea from "@/components/HiTextArea";
// import { collections } from "@/db";
import {
  Editor,
  EditorContent,
  EditorMenuBubble,
  EditorFloatingMenu
} from "tiptap";
import {
  Blockquote,
  BulletList,
  HardBreak,
  Heading,
  ListItem,
  OrderedList,
  Bold,
  Italic,
  Link,
  Strike,
  Underline,
  History
} from "tiptap-extensions";

export default {
  name: "DLEditor",
  components: { HiDialog, EditorContent, EditorMenuBubble, EditorFloatingMenu },
  props: {
    title: {
      type: String,
      content: String
    }
  },
  data() {
    return {
      isOpen: false,
      keepInBounds: true,
      editor: null,
      saving: false,
      errorMsg: null
    };
  },
  methods: {
    open(content) {
      this.isOpen = true;
      this.saving = false;
      // console.log(this.editor);
      if (content) {
        this.editor.setContent(content);
        // this.$refs.content.$el.firstChild.innerHTML = content;
      }
    },
    close() {
      this.isOpen = false;
      this.saving = false;
    },
    save() {
      this.$emit("save", this.editor.getHTML());
      this.saving = true;
    },
    error(msg) {
      this.saving = false;
      this.errorMsg = msg;
    }
  },
  mounted() {
    this.editor = new Editor({
      extensions: [
        new Blockquote(),
        new BulletList(),
        new HardBreak(),
        new Heading({ levels: [1, 2, 3] }),
        new ListItem(),
        new OrderedList(),
        new Link(),
        new Bold(),
        new Italic(),
        new Strike(),
        new Underline(),
        new History()
      ],
      autoFocus: true,
      content: this.content
    });
  },
  beforeDestroy() {
    this.editor.destroy();
  }
};
</script>

<style scoped lang="scss">
$bg-dark: $dark-bg-4;
$bg-over: $dark-bg-1;
.menububble {
  position: absolute;
  display: flex;
  z-index: 20;
  background: $bg-dark;
  border-radius: 5px;
  padding: 0;
  margin-bottom: 0.5rem;
  transform: translateX(-50%);
  visibility: hidden;
  opacity: 0;
  transition: opacity 0.2s, visibility 0.2s;
  box-shadow: 1px 1px 4px #262626;
  //opacity: 0.6;

  &.is-active {
    opacity: 1;
    visibility: visible;
  }

  &__button {
    display: inline-flex;
    background: transparent;
    border: 0;
    color: white;
    padding: 0.2rem;
    margin-right: 1px;
    border-radius: 3px;
    cursor: pointer;

    &:last-child {
      margin-right: 0;
    }

    &:hover {
      background-color: rgba(white, 0.2);
    }

    &.is-active {
      background-color: rgba(white, 0.3);
    }
  }

  &__form {
    display: flex;
    align-items: center;
  }

  &__input {
    font: inherit;
    border: none;
    background: transparent;
    color: white;
  }
}
//.ProseMirror:focus {
//  outline: none !important;
//}
::v-deep div:focus {
  outline: none !important;
}
.editor {
  width: 100%;
  position: relative;
  background-color: rgba(255, 255, 255, 0.3);
  padding: 20px;
  //margin: 0 auto 5rem auto;

  &__content {
    display: inline-block;
    width: 100%;
    height: 100%;
    overflow-wrap: break-word;
    word-wrap: break-word;
    word-break: break-word;

    * {
      caret-color: currentColor;
    }

    pre {
      padding: 0.7rem 1rem;
      border-radius: 5px;
      background: black;
      color: white;
      font-size: 0.8rem;
      overflow-x: auto;

      code {
        display: block;
      }
    }

    ul,
    ol {
      padding-left: 1rem;
    }

    li > p,
    li > ol,
    li > ul {
      margin: 0;
    }

    a {
      color: inherit;
    }
    ::v-deep p {
      margin-bottom: 0 !important;
    }
    blockquote {
      border-left: 3px solid rgba(black, 0.1);
      color: rgba(black, 0.8);
      padding-left: 0.8rem;
      font-style: italic;

      p {
        margin: 0;
      }
    }

    img {
      max-width: 100%;
      border-radius: 3px;
    }

    table {
      border-collapse: collapse;
      table-layout: fixed;
      width: 100%;
      margin: 0;
      overflow: hidden;

      td,
      th {
        min-width: 1em;
        border: 2px solid grey;
        padding: 3px 5px;
        vertical-align: top;
        box-sizing: border-box;
        position: relative;
        > * {
          margin-bottom: 0;
        }
      }

      th {
        font-weight: bold;
        text-align: left;
      }

      .selectedCell:after {
        z-index: 2;
        position: absolute;
        content: "";
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        background: rgba(200, 200, 255, 0.4);
        pointer-events: none;
      }

      .column-resize-handle {
        position: absolute;
        right: -2px;
        top: 0;
        bottom: 0;
        width: 4px;
        z-index: 20;
        background-color: #adf;
        pointer-events: none;
      }
    }

    .tableWrapper {
      margin: 1em 0;
      overflow-x: auto;
    }

    .resize-cursor {
      cursor: ew-resize;
      cursor: col-resize;
    }
  }
  &__floating-menu {
    position: absolute;
    z-index: 1;
    margin-top: -0.25rem;
    visibility: hidden;
    opacity: 0;
    transition: opacity 0.2s, visibility 0.2s;
    &.is-active {
      opacity: 1;
      visibility: visible;
    }
  }
}

.menubar {
  margin-bottom: 1rem;
  transition: visibility 0.2s 0.4s, opacity 0.2s 0.4s;

  &.is-hidden {
    visibility: hidden;
    opacity: 0;
  }

  &.is-focused {
    visibility: visible;
    opacity: 1;
    transition: visibility 0.2s, opacity 0.2s;
  }

  &__button {
    font-weight: bold;
    display: inline-flex;
    background: transparent;
    border: 0;
    color: $bg-dark;
    padding: 0.2rem 0.5rem;
    margin-right: 0.2rem;
    border-radius: 3px;
    cursor: pointer;
    opacity: 0.3;

    &:hover {
      background-color: rgba($bg-dark, 0.05);
      opacity: 1;
    }

    &.is-active {
      background-color: rgba($bg-dark, 0.1);
    }
  }

  span#{&}__button {
    font-size: 13.3333px;
  }
}
</style>
